import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Calendar from './views/calendar.vue'

Vue.use(Router)


const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/calendar',
    name: 'calendar',
    component: Calendar
  }

]

const router = new Router({
  routes,
  mode: 'history'
})

export default router